
import React from 'react';
import { useTransition, animated } from 'react-spring';
import Easing from 'bezier-easing';

const enterBezier = Easing(0.4, 0.0, 0.2, 1.0);
const leaveBezier = Easing(0.4, 0.0, 0.6, 1.0);

const STYLE = {
  position: 'absolute' as const,
  height: '100%',
  width: '100%',
  background: 'rgba(0, 0, 0, 0.5)',
  zIndex: 30
};

export interface AnimatedModalMaskProps {
  visible: boolean;
  style?: React.CSSProperties;
  disableAnimation?: boolean;
}

const AnimatedModalMask:React.FC<AnimatedModalMaskProps> = ((cProps: AnimatedModalMaskProps) => {
  const { visible, style, disableAnimation, ...otherProps } = cProps;
  const transitions = useTransition(visible, null, {
    initial: { opacity: 0 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 200, easing: visible ? leaveBezier : enterBezier },
    immediate: disableAnimation,
  });
  return (
    <>
      {transitions.map(({ item, key, props }) =>
        item && (
          <animated.div key={key} style={{ ...props, ...style, ...STYLE }} {...otherProps} />
        ))}
    </>
  );
});
AnimatedModalMask.defaultProps = {
  style: {},
  disableAnimation: undefined,
};
AnimatedModalMask.displayName = 'AnimatedModalMask';
export default AnimatedModalMask;
